<template>
  <div>
    <el-form
      :model="ruleForm"
      status-icon
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="用户ID">
        <el-input v-model="query.user_id" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="会员类别" prop="level_id">
        <el-select
          class="search-el"
          v-model="ruleForm.level_id"
          placeholder="7天免费会员"
        >
          <el-option
            v-for="(item, index) in levelList"
            :key="index"
            :label="item"
            :value="index"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="操作说明" prop="desc">
        <el-input type="input" v-model="ruleForm.desc"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >提交</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getUserVIP, updateUserVIPLevel } from "@/api/user";

export default {
  data() {
    var checkDesc = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("操作说明不能为空"));
      }
      this.query.desc = value;
      callback();
    };
    var validateLevelId = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请选择会员类别"));
      } else {
        this.query.level_id = value;
        callback();
      }
    };

    return {
      updateLoading: false,
      levelList: [],
      query: {
        admin_id: this.$route.query.admin_id,
        admin_name: this.$route.query.admin_name,
        user_id: this.$route.query.user_id,
        level_id: "",
        type: "increase",
        desc: "",
      },

      ruleForm: {
        level_id: "",
        desc: "",
      },
      rules: {
        level_id: [{ validator: validateLevelId, trigger: "blur" }],
        desc: [{ validator: checkDesc, trigger: "blur" }],
      },
    };
  },
  created: function () {
    this.getUserVIP();
  },

  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updateUserVIPLevel();
        } else {
          return false;
        }
      });
    },

    getUserVIP() {
      getUserVIP().then((response) => {
        this.levelList = response.data;
      });
    },
    updateUserVIPLevel() {
      updateUserVIPLevel(this.query).then((response) => {
        if (response.status === "2000") {
          this.$message.success(response.message);
          this.ref();
        } else {
          this.$message.error(response.message);
        }
      });
    },
    ref() {
      window.history.go(-1);
    },
  },
};
</script>